import LogIcon from "../../assets/icons/LogIcon";
import InfoTitle from "./InfoTitle";

type Props = {
  title?: string;
  list?: {
    id: number;
    date?: string;
    log?: string;
  }[];
  className?: string;
};

export default function LogList({
  title = "Log",
  list,
  className = "",
}: Props) {
  return (
    <div
      className={`p-6 bg-white rounded-md border border-extra-light ${className}`}
    >
      <InfoTitle
        className="mb-6"
        buttonClassName="disabled:!text-neutral"
        icon={<LogIcon />}
      >
        {title}
      </InfoTitle>

      <div className="max-h-[400px] overflow-y-auto">
        {list?.map((item) => (
          <div
            className="flex items-center py-4 first:pt-0 last:pb-0 border-b border-extra-light last:border-b-0"
            key={item?.id}
          >
            <div className="w-9">
              <span className="w-2.5 h-2.5 bg-complete rounded-full inline-block" />
            </div>
            <div className="flex-1">
              {item?.date ? (
                <h6 className="text-tint-neutral text-sm font-semibold mb-[3px]">
                  {item?.date}
                </h6>
              ) : null}

              <p className="text-display-body leading-7">{item?.log}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
